module.exports = __webpack_public_path__ + "static/media/sinister_type_fire.a1b9df95.svg";